// client/src/components/TiptapEditor/MenuBar/FontSizeGroup.js
import React, { useCallback } from "react";

export const FontSizeGroup = ({ editor }) => {
  const fontSizes = ["12", "14", "16", "20", "24", "32"];

  const handleFontSizeChange = useCallback(
    (e) => {
      const size = e.target.value;
      if (size === "default") {
        editor.chain().focus().unsetFontSize().run();
        return;
      }
      editor.chain().focus().setFontSize(`${size}px`).run();
    },
    [editor],
  );

  // Comprobamos si la marca 'fontSize' está activa con el tamaño correspondiente
  const activeFontSize = editor.getAttributes("fontSize").fontSize || "default";

  return (
    <select
      value={activeFontSize.replace("px", "")}
      onChange={handleFontSizeChange}
      style={{ marginLeft: "0.5rem" }}
    >
      <option value="default">Tamaño</option>
      {fontSizes.map((size) => (
        <option key={size} value={size}>{`${size}px`}</option>
      ))}
    </select>
  );
};
